import { Link } from '@tanstack/react-router';
import type { Promotion } from '@/domain';
import { cn } from '@/lib/cn';
import { buttonVariants } from '@/ui/common';

export interface PromoCardProps {
  promotion: Promotion;
  viewOfferLabel: string;
  className?: string;
}

export function PromoCard({ promotion, viewOfferLabel, className }: PromoCardProps) {
  return (
    <article
      className={cn(
        'flex w-full flex-col overflow-hidden rounded-md bg-bg-surface lg:max-w-[400px]',
        className,
      )}
    >
      <Link
        to="/promotions/$slug"
        params={{ slug: promotion.slug }}
        className="relative flex h-[140px] shrink-0 items-end overflow-hidden p-3"
        aria-label={promotion.title}
      >
        <img
          src={promotion.imageUrl}
          alt=""
          className="absolute inset-0 size-full object-cover"
          draggable={false}
        />
      </Link>

      <div className="flex flex-col gap-2 p-4">
        <h2 className="text-heading-s text-text-primary">{promotion.title}</h2>
        {promotion.description ? (
          <p className="text-body-s text-text-secondary">{promotion.description}</p>
        ) : null}
        <Link
          to="/promotions/$slug"
          params={{ slug: promotion.slug }}
          className={cn(buttonVariants({ variant: 'secondary', size: 'sm' }), 'w-fit')}
        >
          {viewOfferLabel}
        </Link>
      </div>
    </article>
  );
}
